import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "open"];
import { useState } from 'react';
import { ExpandableSection } from 'foundations-components/transitional/components/ExpandableSection';
import { ExpandableContents } from 'foundations-components/transitional/components/ExpandableContents';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const STORAGE_KEY_SUFFIX = '-default-open-state';
const useExpandableSectionDefaultState = name => {
  const getInitialState = () => {
    const storageKey = `${name}${STORAGE_KEY_SUFFIX}`;
    try {
      const storedValue = localStorage.getItem(storageKey);
      if (storedValue !== null) {
        return JSON.parse(storedValue);
      }
    } catch (error) {
      // localStorage not available, use default
    }
    return true;
  };
  const [defaultOpen] = useState(getInitialState);
  const updateDefaultState = isOpen => {
    const storageKey = `${name}${STORAGE_KEY_SUFFIX}`;
    try {
      localStorage.setItem(storageKey, JSON.stringify(isOpen));
    } catch (error) {
      // localStorage not available, ignore
    }
  };
  return [defaultOpen, updateDefaultState];
};
const ContentWrapper = _ref => {
  let {
      children,
      open
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(ExpandableContents, Object.assign({}, rest, {
    paddingInlineEnd: "0",
    "aria-hidden": open ? 'false' : 'true',
    children: children
  }));
};
const AddPanelExpandableSection = props => {
  const {
    name,
    removeRightPaddingFromContent
  } = props;
  const [defaultOpen, updateDefaultState] = useExpandableSectionDefaultState(name);
  const onOpenChange = e => {
    const isOpen = e.target.value;
    updateDefaultState(isOpen);
    UsageTracker.trackEditorInteraction({
      action: 'Add panel sections opened/closed',
      event: `${name}-${isOpen ? 'opened' : 'closed'}`
    });
  };
  return /*#__PURE__*/_jsx(ExpandableSection, Object.assign({
    "data-test-id": name,
    onOpenChange: onOpenChange,
    defaultOpen: defaultOpen
  }, removeRightPaddingFromContent && {
    ContentWrapper
  }, props, {
    children: props.children
  }));
};
export default AddPanelExpandableSection;